export {
    default as DashboardGeneralCard,
    ITemplateGeneralCardProps,
    ITemplateGeneralCardHeaderProps,
    ITemplateGeneralRowProps,
    ITemplateGeneralTableProps,
} from './dashboard-general-card';
